import type { apiClient } from '~/shared/api/data-ingestion-api'
import { highlightText } from '~/shared/lib/highlight-text'
import { RadioButton, Text } from '~/shared/ui'
import { useFilters } from '../../../../model'

export function PayorItem({ payor, searchValue }: { payor: apiClient.Payor; searchValue: string }) {
  const { filters, setFilters } = useFilters()

  return (
    <div
      className="flex w-full items-center gap-2 px-2 py-1"
      key={payor.payorId}
    >
      <RadioButton
        className="w-full"
        label={
          <div className="flex flex-col whitespace-normal">
            <Text appearance="BODY2">{highlightText(payor.payorName, searchValue)}</Text>
            <Text
              className="text-text-secondary"
              appearance="CAPTION"
            >
              {highlightText(payor.payorId, searchValue)}
            </Text>
          </div>
        }
        fullLabelWidth
        gutter
        size="small"
        checked={filters.payor === payor.payorId}
        onChange={() => {
          setFilters({
            payor: payor.payorId,
          })
        }}
      />
    </div>
  )
}
